<template id="warp_sim12">
    <div class="content1" style="font-size: 16px;">
        <div style="margin: 1rem;">
          <a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
            <a-row type='flex' justify='space-between' style=" align-items: center;">
              <a-col style="width: 30%;">
                <a-form-model-item label="買入時間" class="formItem">
                  <a-range-picker :placeholder="['開始時間','結束時間']" format="YYYY/MM/DD"
                    v-model="params.trade_date" @change='fanhand'>
                  </a-range-picker>
                </a-form-model-item>
              </a-col>
              <a-col style="width: 30%;">
                <a-form-model-item label="賣出時間" class="formItem">
                  <a-range-picker :placeholder="['開始時間','結束時間']" format="YYYY/MM/DD"
                    v-model="params.trade_date1" @change='fanhand1'>
                  </a-range-picker>
                </a-form-model-item>
              </a-col>
              <a-col >
                <div style="display: flex;">
                  <div class="btn_cla" style="background-color:#3bc7a1;font-size: 0.8rem;" @click="searchEvent">
                    <img src="../../../image/icon_sousuo.png" class="btnIcon" />
                    <span style="margin-left:5px;">搜索</span>
                  </div>
                  <div class="btn_cla" style="background-color:#ffa647;margin-left: 1rem;font-size: 0.8rem;" @click="clearEvent">
                    <img src="../../../image/icon_chongzhi.png" class="btnIcon" />
                    <span style="margin-left:5px;">重置</span>
                  </div>
                  <div class="btn_cla" style="background-color:#4784ff;margin-left: 1rem;font-size: 0.8rem;" @click='handpdf'>
                    <img src="../../../image/icon_daochu.png" class="btnIcon" />
                    <span style="margin-left:5px;">導出</span>
                  </div>
                </div>
              </a-col>
            </a-row>
          </a-form-model>    
          <div style="height: 320px;">
            <div style="border: 1px solid #e8e8e8;margin-top: 10px;">
              <el-table
              height='320px'
              :data="tableData"
              :header-cell-style="{ background: '#fafafa', color: '#000' }"
              style="width: 100%;font-size: 0.8rem;">
                <el-table-column
                  align="center"
                  prop="product_code"
                  label="產品編號">
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="transaction_type"
                  label="買入賣出">

                </el-table-column>
                <el-table-column
                  align="center"
                  prop="transaction_amount"
                  label="交易金額">
                  <template slot-scope="scope">
                        <div v-if="scope.row.transaction_type == '買入'" style="color: #3bc7a1;">HKD {{ scope.row.transaction_amount}}</div>
                        <div v-else style="color: #ed4849;">HKD {{ scope.row.transaction_amount}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="submit_date"
                    label="提交時間">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="block_s">
              <a-pagination :defaultPageSize="5" :total="total" @change="onChange" />
          </div>
      </div>
      <div :class="['pdfview',pdfShow?'pdfShow':'']" @click='pdfShowUNEvent()'>
        <div class='pdfviewIn'>
          <div class='pdfTitle'>
            <img src="../../../image/icon_dayin.png" alt=""  @click.stop="printEvent()">
          </div>
          <iframe id='iframePdf1' :src='allurl' style='width:100%;height:100%;' frameborder='0'></iframe>
          <iframe id='toPrintIframe1' style='display:none' :src='pdfBolUrl' frameborder='0'></iframe>
        </div>
      </div>
    </div>
</template>

<script>
import https from '@/plugins/http.js';
import App from '@/assets/app.js';
export default {
  props: ["items"],
  data() {
    return {
      pdfShow:false,
      allurl:'',
      blob:'',
      pdfUrl : '',
      pdfBolUrl:'',
      dataAll:{},
      tableData: [],
      tradetypeArr:[
        {v:'全部',x: ''},
        {v:'存款',x: '0'},
        {v:'提款',x: '1'},
        {v:'貨幣兌換',x: '3'},
      ],
      total:10,
      pageNum:'1',
      params: {
        trade_date: [],
        trade_date1: [],
        trade_date_begin: '', //認購起始日期
        trade_date_end: '', //認購截止日期
        trade_date_begin1: '', //認購起始日期
        trade_date_end1: '', //認購截止日期
        tradetype:''
      }
    };
  },
  mounted() {
   this.getTradeRecords();
  },

  methods: {
    onChange(val){
            console.log(val);
            this.pageNum = val
            this.getTradeRecords(val);
            
        },
    handpdf(){
      let str = this.$api.pdfs;
      let url = this.$api.exportEntrustTradeRecordsPDF;
      url += '?token=' + this.$store.state.token 
      url += '&account_number=' + this.items.account_number
      this.allurl = str + url;
      let _this = this;
      _this.pdfUrl = url;
      https.fetchGetPdf(_this.pdfUrl).then((data)=>{
        let blob = new Blob([data],{
          type:'application/pdf'
        })
        _this.blob = blob;
        let b=window.URL.createObjectURL(blob);
        console.log(b);
        _this.pdfBolUrl = b;
      }).catch(err=>{
        console.log(err)
      })
      setTimeout(()=>{
        this.pdfShow = true
      },500)
    },
    pdfShowUNEvent(){
      this.pdfShow = false
    },
    printEvent(){
      let _this = this;
      const printIframe = document.getElementById("toPrintIframe1");
      let frameWindow = printIframe.contentWindow;
      frameWindow.print();
      setTimeout(()=>{
          window.URL.revokeObjectURL(_this.blob);
      },500)
    },
    getTradeRecords(){
        this.$ajax({
				method: "post",
				url: this.$api.getTradeRecords,
				data: {
					buyBeginTime: this.params.trade_date_begin,
          buyEndTime: this.params.trade_date_end,
					sellBeginTime: this.params.trade_date_begin1,
					sellEndTime: this.params.trade_date_end1,
					account_number: this.items.account_number,
					pageNum: this.pageNum,
				},
        }).then((res) => {
            if (res.data.qmiscode == 1000) {
                this.tableData = res.data.tradeRecords;
                this.dataAll = res.data;
                this.total = res.data.total;
            } else {
                App.oTool.warningT(res.data.qmismsg);
            }
        });
    },
    fanhand(val) {
      this.params.trade_date_begin = this.params.trade_date[0] ? App.oDate.secsTime3(this.params.trade_date[0]._d) : '',
        //認購截止日期
      this.params.trade_date_end = this.params.trade_date[1] ? App.oDate.secsTime3(this.params.trade_date[1] ._d) : '';
    },
    fanhand1(val) {
      this.params.trade_date_begin1 = this.params.trade_date1[0] ? App.oDate.secsTime3(this.params.trade_date1[0]._d) : '',
        //認購截止日期
      this.params.trade_date_end1 = this.params.trade_date1[1] ? App.oDate.secsTime3(this.params.trade_date1[1] ._d) : '';
    },
    searchEvent(){
      this.getTradeRecords()

    },
    clearEvent(){
      this.params = {
        trade_date: [],
        trade_date1: [],
        trade_date_begin: '', //認購起始日期
        trade_date_end: '', //認購截止日期
        trade_date_begin1: '', //認購起始日期
        trade_date_end1: '', //認購截止日期
        tradetype:''
      };
      this.total =5;
      this.pageNum = '1';
      this.getTradeRecords();
    },
  },
};
</script>

<style lang="scss" scoped>
  .btn_cla{
    border-radius: 30px;
    padding: 0.2rem 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    cursor: pointer;
  }
	.content1{
		padding-bottom: 1rem;
		border-radius: 0 0 10px 10px;
		padding: 1rem;
		background-color: #fff;
		margin-bottom: 1rem;
		min-height: 50px;
	}
  .formItem {
    margin: 0;
    width: 100%;
    display: flex;
    align-items: center;
}


.topBtn {
    padding: 0px 1.04rem;
    border-radius: 2.6rem;
    color: #fff;
    // display: inline-flex;
    align-items: center;
}

</style>
<style>
.block_s{
    text-align: right;
    padding-top: 20px;
}
.block_s .ant-pagination-item-active{
    background-color: #f3f3f3;
    border-color: #d8d8d8;
}
.block_s .ant-pagination-item-active a{
    color: #000;
}
.block_s .ant-pagination-next:hover .ant-pagination-item-link{
    color: #000;
    border-color: #d9d9d9;
}
.block_s .ant-pagination-item:hover{
    border-color: #d9d9d9;
}
.block_s .ant-pagination-item:hover a{
    color: rgba(0, 0, 0, 0.65);
}
.formItem .ant-form-item-control-wrapper {
    width: 70%;
}

.pdfview {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0vw;
  top: 0vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 99;
  display: none;
}

.pdfShow {
  display: block;
}

.pdfview .pdfviewIn {
  position: fixed;
  width: 80vw;
  height: 80vh;
  left: calc(50% - 40vw);
  top: 5vh;
}

.pdfview .pdfviewIn .pdfTitle {
  /* position: absolute;
    top: 1rem;
    right:3rem; */
  height: 3rem;
  background-color: #fff;
  width: calc(100% + 1px);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 2rem;
}

.pdfview .pdfviewIn .pdfTitle img {
  width: 1.5rem;
  height: 1.5rem;
  margin-left: 1rem;
  cursor: pointer;
}
</style>
